(function () {
  // On sensitive / support pages, stack a neutral history entry so Back is less revealing
  function hardenHistory() {
    var body = document.body;
    if (!body) return;
    var sensitive =
      body.classList.contains('has-safety-bar') ||
      body.getAttribute('data-sensitive') === 'true' ||
      (body.getAttribute('data-template') || '').indexOf('support') !== -1;
    if (!sensitive) return;
    try {
      history.replaceState(null, '', location.href);
      history.pushState(null, '', location.href);
    } catch (e) {}
  }

  hardenHistory();

  var btn = document.getElementById('quick-exit');
  if (!btn) return;

  var SAFE_SITE = btn.getAttribute('data-safe-site') || 'https://www.bbc.co.uk/weather';
  var DECOY_SITE = btn.getAttribute('data-decoy-site') || 'https://www.google.co.uk';

  function quickExit() {
    try {
      document.querySelectorAll('input, textarea').forEach(function (el) {
        el.value = '';
      });
      sessionStorage.clear();
    } catch (e) {}
    try {
      window.open(DECOY_SITE, '_blank', 'noopener,noreferrer');
    } catch (e) {}
    window.location.replace(SAFE_SITE);
  }

  window.quickExitNow = quickExit;
  btn.addEventListener('click', quickExit);

  var taps = [];
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var now = Date.now();
    taps = taps.filter(function (x) {
      return now - x < 1500;
    });
    taps.push(now);
    if (taps.length >= 3) quickExit();
  });
})();
